// Element Loader
// Desc: Loads All Elements Dynamically

import Vue from "vue";
Vue.config.ignoredElements = [/ov-*/];

const requiredElement = require.context(
  "@/theme/elements/",
  true,
  /\.(sass|scss|js)$/
);
requiredElement.keys().forEach(fileName => {
  requiredElement(fileName);
});
